<div class="container">
    <div class="top">
        <div class="title">{{ "deliveryChoice.subtitle" | translate}}</div>
        <img class="quit_cross" src="assets/images/quit_cross.svg" (click)="onNoClick()">
    </div>
    <div class="buttons">
        <div class="button">
            <app-button buttonTitle="deliveryChoice.button.home" buttonSubtitle="deliveryChoice.button.home_sub" picto="assets/images/reprogrammer.svg" (click)="openHomeDeliveryChoice()">
            </app-button>
        </div>
        <div class="button">
            <app-button buttonTitle="deliveryChoice.button.pick_up" buttonSubtitle="deliveryChoice.button.pick_up_sub" picto="assets/images/picto_livraison_BP.svg" (click)="openPickupDeliveryChoice()">
            </app-button>
        </div>
    </div>

</div>